import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import {
  CLINIC_FILTER_RESET,
  CLINIC_PROVIDER_RESET,
} from "../../redux/constants/providerConstants";
import UserToggleModal from "../HomeScreen/Modals/UserToggleModal";
import { toast } from "react-toastify";
import "./ClinicScreen.css";
import FilterUsers from "./FilterUsers";
import ShowData from "./ShowData";
import EditModal from "./Modals/EditModal";
import {
  clinicFilterAction,
  clinicProvidersAction,
  providerAssessmentAction,
} from "../../redux/actions/providerActions";
import Content from "../../components/Content";
import {
  logout,
  activatemanageUserAction,
  updatemanageUserAction,
} from "../../redux/actions/userActions";
import {
  ACTIVATE_MANAGE_USER_RESET,
  UPDATE_MANAGE_USER_RESET,
} from "../../redux/constants/userConstants";
import { getDayDiff } from "../../utils/validators";

function Index({ history }) {
  const dispatch = useDispatch();

  const clinicProvider = useSelector((state) => state.clinicProvider);
  const clinicFilter = useSelector((state) => state.clinicFilter);
  const userLogin = useSelector((state) => state.userLogin);
  const activeToken = useSelector((state) => state.activeToken);
  const activatemanageUser = useSelector((state) => state.activatemanageUser);
  const [userIndex, setUserIndex] = useState(1);
  const [usersList, setUsersList] = useState([]);
  const [totalusersList, setTotalUsersList] = useState([]);
  const perPageUser = 10;
  const totalPages = Math.ceil(totalusersList / perPageUser);
  const [showFilter, setShowFilter] = useState(true);
  const [UserId, setUserId] = useState("");
  const [isDeleted, setIsDeleted] = useState(false);
  const [modalActiveState, setModalActiveState] = useState(false);

  const [filterData, setFilterData] = useState({
    BirthDate: "",
    FirstName: "",
    LastName: "",
    assessmentrange: 0,
    endDate: "",
    providerId: "",
    riskRating: "",
    startDate: "",
  });
  const [filter, setFilter] = useState({
    provider: "All",
    clinic: "0",
    role: "Patient",
    confirmed: "All",
  });
  const updatemanageUser = useSelector((state) => state.updatemanageuser);

  // Edit User
  const [modalEditState, setModalEditState] = useState(false);
  const [updateUser, setupdateUser] = useState({
    userId: "",
    fName: "",
    lName: "",
    email: "",
    error: "",
    birthDate: "",
    birthDateerror: "",
    clinic: "",
    clinicError: "",
    clinicName: "",
    provider: "",
    providerError: "",
    // EHRId: "",
    // EHRIdError: "",
    MRNId: "",
    MRNIdError: "",
    IsModMedEnabled: false,
    IsAthenaEnabled: false,
  });
  const [updateUserConfirm, setupdateUserConfirm] = useState({
    status: false,
    newClinic: "",
    oldClinic: "",
    newProvider: "",
    oldProvider: "",
  });

  const handleEditUserConfirmation = () => {
    const formData = {
      userId: updateUser.userId,
      email: updateUser.email,
      firstName: updateUser.fName,
      lastName: updateUser.lName,
      birthDate: updateUser.birthDate,
      clinicId: updateUser.clinic,
      providerId: updateUser.provider,
      // EHRId: updateUser.EHRId,
      MRNId: updateUser.MRNId,
      IsModMedEnabled: updateUser.isModMedEnabled,
      IsAthenaEnabled: updateUser.isAthenaEnabled
    };
    dispatch(updatemanageUserAction(formData));
  };

  useEffect(() => {
    if (
      updatemanageUser &&
      updatemanageUser.data &&
      updatemanageUser.data.statusCode === true
    ) {
      toast.success(updatemanageUser.data.message);

      getManageUsers(totalPages);

      dispatch({ type: UPDATE_MANAGE_USER_RESET });

      setModalEditState(false);

      setupdateUser({
        userId: "",
        fName: "",
        lName: "",
        email: "",
        error: "",
        birthDate: "",
        birthDateerror: "",
        clinic: "",
        clinicError: "",
        provider: "",
        providerError: "",
        // EHRId: "",
        // EHRIdError: "",
      });

      setupdateUserConfirm({
        status: false,
        newClinic: "",
        oldClinic: "",
        newProvider: "",
        oldProvider: "",
      });
    } else if (updatemanageUser && updatemanageUser.error) {
      toast.error(updatemanageUser.error);
    }
  }, [updatemanageUser]);

  useEffect(() => {
    if (!activeToken) {
      history.push("/login");
    } else if (!activeToken.token) {
      history.push("/login");
    } else if (
      userLogin &&
      userLogin.userInfo &&
      userLogin.userInfo.applicationUser &&
      userLogin.userInfo.applicationUser.isPatient === true &&
      userLogin.userInfo.applicationUser.isSuperAdmin === false
    ) {
      history.push("/questionaires");
    }
  }, [activeToken, userLogin, history]);

  useEffect(() => {
    const userInfo = localStorage.getItem("userInfo");
    const tokenInfo = localStorage.getItem("token");
    const clientIdInfo = localStorage.getItem("clientId");
    const getMenusInfo = localStorage.getItem("getMenus");

    if (userInfo === "undefined" || userInfo === undefined) {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      localStorage.removeItem("clientId");
      localStorage.removeItem("clientUrl");
      localStorage.removeItem("getMenus");
      history.push("/login");
      dispatch(logout());
    } else if (tokenInfo === "undefined" || tokenInfo === undefined) {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      localStorage.removeItem("clientId");
      localStorage.removeItem("clientUrl");
      localStorage.removeItem("getMenus");
      history.push("/login");
      dispatch(logout());
    } else if (clientIdInfo === "undefined" || clientIdInfo === undefined) {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      localStorage.removeItem("clientId");
      localStorage.removeItem("clientUrl");
      localStorage.removeItem("getMenus");
      history.push("/login");
      dispatch(logout());
    } else if (getMenusInfo === "undefined" || getMenusInfo === undefined) {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      localStorage.removeItem("clientId");
      localStorage.removeItem("clientUrl");
      localStorage.removeItem("getMenus");
      history.push("/login");
      dispatch(logout());
    }
  }, [dispatch]);

  //Active User Toggle
  useEffect(() => {
    if (
      activatemanageUser &&
      activatemanageUser.data &&
      activatemanageUser.data.message === "Success"
    ) {
      getManageUsers(totalPages);
      toast.success(activatemanageUser.data.message);
      dispatch({ type: ACTIVATE_MANAGE_USER_RESET });
      setModalActiveState(false);
      setUserId("");
      setIsDeleted(false);
    }
  }, [activatemanageUser, dispatch]);

  useEffect(() => {
    if (userLogin && userLogin.userInfo && !userLogin.userInfo.token) {
      dispatch(logout());
      history.push("/login");
    } else if (!localStorage.getItem("userInfo")) {
      dispatch(logout());
      history.push("/login");
    } else {
      dispatch(clinicProvidersAction());
      var formData = {
        BirthDate: "",
        FirstName: "",
        LastName: "",
        assessmentrange: 0,
        endDate: "",
        providerId: "All",
        riskRating: "",
        startDate: "",
      };
      dispatch(clinicFilterAction(formData));
    }
  }, [userLogin, history, dispatch]);

  useEffect(() => {
    if (clinicFilter && clinicFilter.data && clinicFilter.data.length > 0) {
      setUsersList(clinicFilter.data.slice(0, perPageUser));
      setTotalUsersList(clinicFilter.data.length);
    } else if (
      clinicFilter &&
      clinicFilter.data &&
      clinicFilter.data.length === 0
    ) {
      setUsersList(clinicFilter.data.slice(0, perPageUser));
    }
  }, [clinicFilter]);
  useEffect(() => {
    return () => {
      dispatch({ type: CLINIC_PROVIDER_RESET });
      dispatch({ type: CLINIC_FILTER_RESET });
    };
  }, [dispatch]);

  const handleAssessment = (id) => {
    dispatch(providerAssessmentAction(id));
  };

  const getManageUsers = (selectedPage) => {
    let data = { ...clinicFilter };
    if (filter.provider) {
      data.providerId = filter.provider;
    }
    if (filter.clinic) {
      data.clinicId = filter.clinic;
    }
    if (filter.role) {
      data.role = filter.role;
    }
    if (filter.confirmed) {
      data.emailConf = filter.confirmed;
    }
    data.pageNumber = selectedPage;
    data.rowsOfPage = perPageUser;
    dispatch(clinicFilterAction(data));
  };

  const editEmailHandler = () => {
    if (!updateUser.birthDate) {
      setupdateUser((prev) => ({
        ...prev,
        birthDateerror: "Please enter date of birth",
      }));
    } else if (getDayDiff(updateUser.birthDate) < 365) {
      setupdateUser((prev) => ({
        ...prev,
        birthDateerror:
          "It seems you’ve entered your date of birth as a day within the last year. Please ensure that you enter your birthday correctly before proceeding.",
      }));
    } else if (!updateUser.birthDate) {
      setupdateUser((prev) => ({
        ...prev,
        birthDateerror: "Please enter date of birth",
      }));
    } 
    // else if ((updateUser.IsModMedEnabled || updateUser.IsAthenaEnabled) && !updateUser.EHRId) {
    //   setupdateUser((prev) => ({
    //     ...prev,
    //     EHRIdError: "Please enter valid EHR Id",
    //   }));
    // } else if ((updateUser.IsModMedEnabled || updateUser.IsAthenaEnabled)  &&
    //   updateUser.EHRId &&
    //   updateUser.EHRId.length < 8
    // ) {
    //   setupdateUser((prev) => ({
    //     ...prev,
    //     EHRIdError: "Minimum 8 characters required.",
    //   }));
    // } 
    // else if (updateUser.IsModMedEnabled && !updateUser.MRNId) {
    //   setupdateUser((prev) => ({
    //     ...prev,
    //     MRNIdError: "Please enter valid EHR ID.",
    //   }));
    // }
     else {
      if (updateUserConfirm.oldClinic !== updateUserConfirm.newClinic) {
        setupdateUserConfirm((prevVal) => ({ ...prevVal, status: true }));
      } else {
        handleEditUserConfirmation();
      }
    }
  };

  const handleClear = () => {
    setFilterData({
      ...filterData,
      BirthDate: "",
      FirstName: "",
      LastName: "",
      assessmentrange: 0,
      endDate: "",
      providerId: "",
      riskRating: "",
      startDate: "",
    });
    var formData = {
      BirthDate: "",
      FirstName: "",
      LastName: "",
      assessmentrange: 0,
      endDate: "",
      providerId: "All",
      riskRating: "",
      startDate: "",
    };
    setUserIndex(1);
    dispatch(clinicFilterAction(formData));
  };
  const handleToday = () => {
    var currentTime = new Date();
    var formData = {
      BirthDate: "",
      FirstName: "",
      LastName: "",
      assessmentrange: 0,
      endDate: "",
      providerId: "All",
      riskRating: "",
      startDate: "",
      todayDate: currentTime,
    };
    setUserIndex(1);
    dispatch(clinicFilterAction(formData));
  };
  const onActive = () => {
    if (UserId !== "") {
      console.log(UserId, isDeleted, "activatemanageUserAction");
      dispatch(activatemanageUserAction(UserId, isDeleted));
    }
  };

  const onEditClose = () => {
    setModalEditState(false);
    setupdateUser({ ...updateUser, error: "" });
    setModalActiveState(false);
    setUserId("");
    setIsDeleted(false);
  };

  const handleFilter = () => {
    var formData = {
      BirthDate: filterData.BirthDate,
      FirstName: filterData.FirstName,
      LastName: filterData.LastName,
      assessmentrange: filterData.assessmentrange,
      endDate: filterData.endDate,
      providerId: filterData.providerId,
      riskRating: filterData.riskRating,
      startDate: filterData.startDate,
    };
    setUserIndex(1);
    dispatch(clinicFilterAction(formData));
  };

  let nextContentFrom = 0;
  const handlePageChange = (currentPage) => {
    nextContentFrom = currentPage.selected * perPageUser;
    const nextContentTo = currentPage.selected * perPageUser + 10;
    setUsersList(
      clinicFilter &&
        clinicFilter.data &&
        clinicFilter.data.slice(nextContentFrom, nextContentTo)
    );
    setUserIndex(currentPage.selected * perPageUser + 1);
  };

  return (
    <Content
      current="Dashboard"
      headerTitle="Dashboard"
      currentMenu="Dashboard"
    >
      <FilterUsers
        data={{
          showFilter,
          setShowFilter,
          clinicProvider,
          handleClear,
          handleToday,
          filterData,
          setFilterData,
          handleFilter,
        }}
      />
      <EditModal
        data={{
          modalEditState,
          updateUser,
          setupdateUser,
          onEditClose,
          editEmailHandler,
          updatemanageUser,
          setupdateUserConfirm,
        }}
      />
      <UserToggleModal
        data={{ modalActiveState, onEditClose, onActive, activatemanageUser }}
      />
      <ShowData
        data={{
          clinicFilter,
          showFilter,
          handleAssessment,
          usersList,
          userIndex,
          setModalActiveState,
          setUserId,
          setIsDeleted,
          setModalEditState,
          setupdateUserConfirm,
          setupdateUser,
        }}
        loading={clinicFilter && clinicFilter.loading}
      />

      {clinicFilter && clinicFilter.data && clinicFilter.data.length > 10 && (
        <div className="tableContainer--paginater">
          <ReactPaginate
            nextClassName={""} //clientList.data.result.length < rowsPerPage && "nextClassName"
            previousLabel={"<"}
            nextLabel={">"}
            pageCount={totalPages}
            onPageChange={handlePageChange}
            marginPagesDisplayed={1}
            pageRangeDisplayed={5}
            containerClassName={"paginationBttns"}
            previousLinkClassName={"previousBttn"}
            nextLinkClassName={"nextBttn"}
            disabledClassName={"paginationDisabled"}
            activeClassName={"paginationActive"}
          />
        </div>
      )}
    </Content>
  );
}

export default Index;
